import { render, staticRenderFns } from "./WHPhoto.vue?vue&type=template&id=32982c6b&"
import script from "./WHPhoto.vue?vue&type=script&lang=js&"
export * from "./WHPhoto.vue?vue&type=script&lang=js&"
import style0 from "./WHPhoto.vue?vue&type=style&index=0&id=32982c6b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports